import React from 'react';
import { Search } from '../../search/components/Search';
import { Tags } from '../../tag/components/Tags';
import { Assets } from '../../finder/components/Assets';
import { AppLayout } from '../../app/components/AppLayout';
import '../styles.scss';
import { RoutedFullscreenPreview } from '../../fullscreenPreview/components/RoutedFullscreenPreview';
import { routes } from '../../router/model';
import { ThemeContext } from '../../../../general/components/FullscreenPreview/model';
import { getViewMode } from '../../viewMode/selectors';
import { useSelector } from 'react-redux';
import { ViewMode } from '../../viewMode/model';
import { CreativeFilter } from './CreativeFilter';
import { PageTabs } from '../../app/components/PageTabs';
import { GetStartedWidget } from '../../getStarted';
import { GET_STARTED_ENABLED } from '../../getStarted/config';
import { UploadButton } from '../../uploader/components/UploadButton';
import { UploadDropOverlay } from '../../uploader/components/UploadDropOverlay';
import { EmptyCatalogUpload } from '../../uploader/components/EmptyCatalogUpload';
import { DetailsToggleButton } from '../../finder/components/DetailsToggleButton';

export const ViewerPage = () => {
  const viewMode = useSelector(getViewMode);
  const rightSider = viewMode !== ViewMode.creatives;

  return (
    <AppLayout leftSider={true} rightSider={rightSider}>
      <RoutedFullscreenPreview parentPath={routes.viewer} />
      {GET_STARTED_ENABLED && <GetStartedWidget />}
      <div className="al-viewer-page">
        <div className="al-viewer-page-top">
          <div className="al-viewer-page-header">
            <div className="al-viewer-page-header__left">
              <Search />
            </div>
            <PageTabs />
            {rightSider && <UploadButton />}
            {rightSider && <DetailsToggleButton />}
          </div>
          <Tags />
        </div>
        <div className="al-viewer-page-content">
          <ThemeContext.Provider value={{ invert: true }}>
            <Assets
              header={<CreativeFilter />}
              // The upload modal (progress) is mounted with UploadButton, i.e. only here.
              emptyContent={rightSider ? <EmptyCatalogUpload /> : undefined}
            />
          </ThemeContext.Provider>
          <UploadDropOverlay />
        </div>
      </div>
    </AppLayout>
  );
};
